export enum CompletionTypeEnum {
  ReadAndUnderstood = 'Read And Understood',
  DocumentUpload = 'Document Upload',
  TrainerSignOff = 'Trainer Sign Off',
  Quiz = 'Quiz',
}
